import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withMessages, { FormattedHTMLMessage } from 'component-utilities/intl';
import { formatDate, DATE_FORMATS } from 'component-utilities/dates/dates';

import InputDivWithKeys from '../Forms/InputFields-DIV/InputDivWithKeys';
import FormRow from './Components/FormRow';
import FormFieldAddon from './Components/FormFieldAddon';
import SelectGenerator from '../Forms/Selects-v2/SelectGenerator';
import SelectMultiSelectGenerator from '../Forms/Selects-v2/SelectMultiSelectGenerator';
import filterStateLogic from '../Dropdowns/Filter/Components/filterStateLogic';
import CalendarSearch from '../Calendar/CalendarSearch';
import PrimaryButton from '../Buttons/PrimaryButton';
import SecondaryButton from '../Buttons/SecondaryButton';
import ButtonSpacer from '../Buttons/Spacer';
import TooltipGrayIcon from '../Icons/TooltipGrayIcon';
import Tooltip from '../Tooltip/Tooltip';
import FormText from '../Forms/FormText';
import FormHint from '../Forms/FormHint';

import LargeCheckbox from '../Forms/Checkboxes/LargeCheckbox';
import FormErrorText from '../Forms/FormErrorText';

import {
    DATE_TYPES,
    ATTACHMENT_TYPES,
    SIZE_TYPES,
    FORM_FIELDS,
} from '../Dropdowns/Filter/config';

import styles from './Search.scss';

export { FORM_FIELDS, DATE_TYPES, ATTACHMENT_TYPES, SIZE_TYPES };

const { KEYWORDS, SENDER, PARTICIPANTS, DATE, SIZE, SENDER_DOMAINS,
    PARTICIPANTS_DOMAINS, HOLD_REASON, ATTACHMENTS, KEYWORDS_EXACT } = FORM_FIELDS;

const BASE_KEY = 'components.dropdowns.filter';
const SEARCH_BASE_KEY = 'components.search';

const SelectSmall = SelectGenerator('small', styles);
const SelectMedium = SelectGenerator('medium', styles);
const SelectMediumMultiSelect = SelectMultiSelectGenerator('medium', styles);

@withMessages
@filterStateLogic({})
export default class SimpleSearchForm extends Component {
    static propTypes = {
        getMessage: PropTypes.func.isRequired,
        formValues: PropTypes.object.isRequired,
        onFormChange: PropTypes.func.isRequired,
        onMultiSelectChange: PropTypes.func.isRequired,
        onDeleteItem: PropTypes.func.isRequired,
        holdReasons: PropTypes.array.isRequired,
        onSearch: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        onInputChange: PropTypes.func.isRequired,
        getLocalizedData: PropTypes.func.isRequired,
        isRangeDate: PropTypes.bool.isRequired,
        isFormHasValues: PropTypes.bool.isRequired,
        isValidForm: PropTypes.bool.isRequired,
        isKeywordListEnabled: PropTypes.bool.isRequired,
        onKeywordListClick: PropTypes.func.isRequired,
        isUserListEnabled: PropTypes.bool.isRequired,
        onSenderListClick: PropTypes.func.isRequired,
        onParticipantsListClick: PropTypes.func.isRequired,
        isFieldEnabled: PropTypes.func.isRequired,
        emailMatchDetails: PropTypes.object,
        isKeywordExact: PropTypes.bool,
        showMatchKeywordExact: PropTypes.bool,
        showDomains: PropTypes.bool,
        isSenderDomains: PropTypes.bool,
        isParticipantsDomains: PropTypes.bool,
        parseSearchStringValue: PropTypes.func.isRequired,
        containsInvalidDomain: PropTypes.func.isRequired,
        getDomainsErrorText: PropTypes.func.isRequired,
    };

    static defaultProps = {
        emailMatchDetails: null,
        isKeywordListEnabled: true,
        isUserListEnabled: true,
        isKeywordExact: false,
        showMatchKeywordExact: false,
        showDomains: false,
        isSenderDomains: false,
        isParticipantsDomains: false,
    };

    renderDomainsHelper(fieldKey, domainKey) {
        const {
            formValues,
            getDomainsErrorText,
            containsInvalidDomain,
            parseSearchStringValue,
            getMessage,
        } = this.props;
        const res = [
            <FormErrorText
                field="simple-search-sender-error"
                error={getDomainsErrorText(formValues, fieldKey, domainKey)}
            />,
        ];
        if (
            !getDomainsErrorText(
                formValues,
                fieldKey,
                domainKey,
            ) &&
      containsInvalidDomain(
          formValues[fieldKey].query,
          formValues[domainKey].query,
          parseSearchStringValue,
      )
        ) {
            res.push(<FormHint>
                { getMessage(`${SEARCH_BASE_KEY}.domains.char_error`)}
            </FormHint>,);
        }
        return res;
    }

    render() {
        const {
            holdReasons,
            getMessage,
            onSearch,
            onCancel,
            onInputChange,
            onMultiSelectChange,
            onDeleteItem,
            onFormChange,
            getLocalizedData,
            isRangeDate,
            isFormHasValues,
            isValidForm,
            isKeywordListEnabled,
            onKeywordListClick,
            isUserListEnabled,
            onSenderListClick,
            onParticipantsListClick,
            formValues,
            isFieldEnabled,
            emailMatchDetails,
            isKeywordExact,
            isSenderDomains,
            isParticipantsDomains,
            showMatchKeywordExact,
            showDomains,
        } = this.props;

        return (
            <div className={styles['search-body']} data-form="simple-search">
                <span className={styles['search-title']}>
                    {getMessage(`${SEARCH_BASE_KEY}.simple_search`)}
                </span>
                <span className={styles['search-instructions']}>
                    {getMessage(`${SEARCH_BASE_KEY}.results`)}
                </span>
                {isFieldEnabled(KEYWORDS) && (
                    <div>
                        <FormRow label={getMessage(`${BASE_KEY}.labels.${KEYWORDS}`)}>
                            <div className={styles['input-field-container']}>
                                <InputDivWithKeys
                                    keys={formValues[KEYWORDS].items || []}
                                    dataField={KEYWORDS}
                                    onDeleteKey={id => onDeleteItem(KEYWORDS, id)}
                                    onInputChange={value => onInputChange(KEYWORDS, value)}
                                    inputValue={formValues[KEYWORDS].query}
                                />
                            </div>
                            <FormFieldAddon
                                type={`${KEYWORDS}-list`}
                                label={getMessage(`${BASE_KEY}.lists.keywords`)}
                                onClick={onKeywordListClick}
                                enabled={isKeywordListEnabled}
                            />
                        </FormRow>
                        {showMatchKeywordExact && <div className={styles.exact}>
                            <LargeCheckbox
                                checked={isKeywordExact}
                                onClick={() => onInputChange(
                                    KEYWORDS_EXACT,
                                    !isKeywordExact,
                                )}
                            >
                                {this.props.getMessage('app.criterias.exact')}
                            </LargeCheckbox>
                        </div>}
                    </div>
                )}
                {isFieldEnabled(SENDER) && (
                    <div>
                        <FormRow label={getMessage(`${BASE_KEY}.labels.${SENDER}`)}>
                            <div className={styles['input-field-container']}>
                                <InputDivWithKeys
                                    keys={formValues[SENDER].items || []}
                                    dataField={SENDER}
                                    onDeleteKey={id => onDeleteItem(SENDER, id)}
                                    onInputChange={value => onInputChange(SENDER, value)}
                                    inputValue={formValues[SENDER].query}
                                />
                            </div>
                            <FormFieldAddon
                                type={`${SENDER}-list`}
                                label={getMessage(`${BASE_KEY}.lists.user`)}
                                onClick={onSenderListClick}
                                enabled={isUserListEnabled}
                            />
                            { this.renderDomainsHelper(SENDER, SENDER_DOMAINS) }
                        </FormRow>
                        {showDomains &&
                        <div className={styles.exact}>
                            <LargeCheckbox
                                checked={isSenderDomains}
                                onClick={() => onInputChange(
                                    SENDER_DOMAINS,
                                    !isSenderDomains,
                                )}
                            >
                                {this.props.getMessage('app.criterias.domains')}
                            </LargeCheckbox>
                            <Tooltip
                                position="right"
                                type="medium"
                                content={this.props.getMessage('app.new_search.tooltips.domain')}
                            >
                                <TooltipGrayIcon />
                            </Tooltip>
                        </div>
                        }
                    </div>
                )}
                {isFieldEnabled(PARTICIPANTS) && (
                    <div>
                        <FormRow label={getMessage(`${BASE_KEY}.labels.${PARTICIPANTS}`)}>
                            <div className={styles['input-field-container']}>
                                <InputDivWithKeys
                                    keys={formValues[PARTICIPANTS].items || []}
                                    dataField={PARTICIPANTS}
                                    onDeleteKey={id => onDeleteItem(PARTICIPANTS, id)}
                                    onInputChange={value => onInputChange(PARTICIPANTS, value)}
                                    inputValue={formValues[PARTICIPANTS].query}
                                />
                            </div>
                            <FormFieldAddon
                                type={`${PARTICIPANTS}-list`}
                                label={getMessage(`${BASE_KEY}.lists.user`)}
                                onClick={onParticipantsListClick}
                                enabled={isUserListEnabled}
                            />
                            { this.renderDomainsHelper(PARTICIPANTS, PARTICIPANTS_DOMAINS) }
                        </FormRow>
                        {showDomains &&
                        <div className={styles.exact}>
                            <LargeCheckbox
                                checked={isParticipantsDomains}
                                onClick={() => onInputChange(
                                    PARTICIPANTS_DOMAINS,
                                    !isParticipantsDomains,
                                )}
                            >
                                {this.props.getMessage('app.criterias.domains')}
                            </LargeCheckbox>
                            <Tooltip
                                position="right"
                                type="medium"
                                content={this.props.getMessage('app.new_search.tooltips.domain')}
                            >
                                <TooltipGrayIcon />
                            </Tooltip>
                        </div>
                        }
                    </div>
                )}
                {isFieldEnabled(DATE) && (
                    <FormRow label={getMessage(`${BASE_KEY}.labels.${DATE}`)}>
                        <SelectSmall
                            id="date_select"
                            onSelect={onFormChange(DATE, 'type')}
                            selectedId={formValues[DATE].type}
                            data={getLocalizedData(DATE, DATE_TYPES)}
                            placeholder={getMessage(`${BASE_KEY}.placeholders.dates`)}
                        />
                        {!!formValues[DATE].type && (
                            <span className={styles['dropdown-calendar']}>
                                <input
                                    type="text"
                                    className={styles['input-field']}
                                    name="start-date"
                                    maxLength={8}
                                    data-field={`${DATE}-from`}
                                    placeholder={isRangeDate ? 'Start date' : 'Date'}
                                    value={
                                        formValues[DATE].from
                                            ? formatDate(formValues[DATE].from, DATE_FORMATS.SHORT)
                                            : ''
                                    }
                                    readOnly
                                />
                                <span className={styles['icon-calendar']} />
                                <span className={styles['dropdown-box']}>
                                    <CalendarSearch
                                        onDateSelected={onFormChange(DATE, 'from')}
                                        selectedDate={formValues[DATE].from}
                                        maxDate={isRangeDate ? formValues[DATE].to : null}
                                    />
                                </span>
                            </span>
                        )}
                        {isRangeDate && <span className={styles['date-range-to']}>
                            to
                        </span>}
                        {isRangeDate && (
                            <span className={styles['dropdown-calendar']}>
                                <input
                                    type="text"
                                    className={styles['input-field']}
                                    name="end-date"
                                    maxLength={8}
                                    data-field={`${DATE}-to`}
                                    placeholder="End date"
                                    value={
                                        formValues[DATE].to ? formatDate(formValues[DATE].to, DATE_FORMATS.SHORT) : ''
                                    }
                                    readOnly
                                />
                                <span className={styles['icon-calendar']} />
                                <span className={styles['dropdown-box']}>
                                    <CalendarSearch
                                        onDateSelected={onFormChange(DATE, 'to')}
                                        selectedDate={formValues[DATE].to}
                                        minDate={formValues[DATE].from}
                                    />
                                </span>
                            </span>
                        )}
                    </FormRow>
                )}
                {isFieldEnabled(ATTACHMENTS) && (
                    <FormRow label={getMessage(`${BASE_KEY}.labels.${ATTACHMENTS}`)}>
                        <div data-field={ATTACHMENTS}>
                            <SelectMedium
                                id="attachment-field"
                                placeholder={getMessage(`${BASE_KEY}.placeholders.attachment`)}
                                onSelect={onFormChange(ATTACHMENTS, 'query')}
                                selectedId={formValues[ATTACHMENTS].query}
                                data={getLocalizedData(ATTACHMENTS, ATTACHMENT_TYPES)}
                            />
                        </div>
                    </FormRow>
                )}
                {isFieldEnabled(SIZE) && (
                    <FormRow label={getMessage(`${BASE_KEY}.labels.${SIZE}`)}>
                        <div data-field={SIZE}>
                            <SelectMediumMultiSelect
                                id="size-field"
                                placeholder={getMessage(`${BASE_KEY}.placeholders.size`)}
                                onSelect={onMultiSelectChange(SIZE, 'query')}
                                selectedIds={formValues[SIZE].query || []}
                                data={getLocalizedData(SIZE, SIZE_TYPES)}
                            />
                        </div>
                    </FormRow>
                )}
                {isFieldEnabled(HOLD_REASON) && (
                    <FormRow label={getMessage(`${BASE_KEY}.labels.${HOLD_REASON}`)}>
                        <div data-field={HOLD_REASON}>
                            <SelectMediumMultiSelect
                                id="hold-reasons-field"
                                placeholder={getMessage(`${BASE_KEY}.placeholders.hold_reason`)}
                                onSelect={onMultiSelectChange(HOLD_REASON, 'query')}
                                selectedIds={formValues[HOLD_REASON].query || []}
                                data={holdReasons}
                            />
                        </div>
                    </FormRow>
                )}
                <hr className={styles.divider} />
                <div className={styles['form-buttons']}>
                    <PrimaryButton
                        onClick={onSearch}
                        disabled={!isFormHasValues || !isValidForm}
                        data-action="search"
                    >
                        {getMessage(`${BASE_KEY}.buttons.search`)}
                    </PrimaryButton>
                    <ButtonSpacer />
                    <SecondaryButton onClick={onCancel} data-action="cancel">
                        {getMessage(`${BASE_KEY}.buttons.cancel`)}
                    </SecondaryButton>
                    <ButtonSpacer />
                    {emailMatchDetails && (
                        <FormText inline>
                            <strong>
                                <FormattedHTMLMessage
                                    id={`${SEARCH_BASE_KEY}.email_count`}
                                    values={{ emailCount: emailMatchDetails.emailCount }}
                                />
                            </strong>
                            <FormattedHTMLMessage
                                id={`${SEARCH_BASE_KEY}.time`}
                                values={{ time: emailMatchDetails.loadingTime }}
                            />
                        </FormText>
                    )}
                </div>
            </div>
        );
    }
}
